import { forwardRef } from "react"
import classnames from "classnames"

export const Bookmark = () => {
  return (
    <svg
      className="icon bookmark"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path d="M62.1,81.3l-12-14.7l-12,14.7V20.8h24V81.3z" />
      </g>
    </svg>
  )
}

export const Back = () => {
  return (
    <svg
      className="icon back"
      version="1.1"
      id="arrow2_x5F_left"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M41.8,49.8L54,37.6c1.4-1.4,3.9-1.4,5.4,0c1.4,1.5,1.4,4,0,5.4l-9.5,9.5l9.5,9.4c1.4,1.5,1.4,3.9,0,5.4
          c-1.5,1.4-4,1.4-5.4,0L41.8,55.2c-0.7-0.7-1.2-1.8-1.2-2.7C40.6,51.5,41.1,50.5,41.8,49.8z"
        ></path>
      </g>
    </svg>
  )
}

export const Forward = () => {
  return (
    <svg
      className="icon forward"
      version="1.1"
      id="arrow2_x5F_right"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M59.6,55.2L47.5,67.4c-1.4,1.4-3.9,1.4-5.4,0c-1.4-1.5-1.4-4,0-5.4l9.5-9.5L42,43c-1.4-1.5-1.4-3.9,0-5.4
          c1.5-1.4,4-1.4,5.4,0l12.2,12.2c0.7,0.7,1.2,1.8,1.2,2.7C60.8,53.5,60.4,54.4,59.6,55.2z"
        ></path>
      </g>
    </svg>
  )
}

export const MagnifyingGlass = ({ className = "" }) => {
  return (
    <svg
      className={`icon magnifying-glass ${className}`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M57.3,62.1c-4.2,0.4-8.3-0.7-11.9-3.2l-2.6,8.2L34.6,77c-0.7,0.9-1.8,1.1-2.8,1.2c-2.6,0.2-5-1.9-5.2-4.4
          c-0.1-1,0.1-2.2,0.7-3l8.2-9.8l7.8-4c-3.1-3-4.9-7.1-5.3-11.2c-0.8-9.7,6.6-18.3,16.2-19.2c9.6-0.8,18.4,6.6,19.3,16.2
          c0.4,4.6-0.9,9.3-4,13C66.2,59.6,61.8,61.7,57.3,62.1z M56.7,55.3c5.8-0.6,10.4-5.9,9.8-12c-0.5-5.8-6-10.4-11.8-9.8
          c-6,0.5-10.5,5.9-10,11.8c0.2,2.9,1.5,5.6,3.8,7.5C51,54.7,53.9,55.6,56.7,55.3z"
        ></path>
      </g>
    </svg>
  )
}

export const pinBodyPath = `M50.2,23.6c-9.6,0-17.2,7.6-17.2,17.1c0,6.6,2.7,9.8,8.5,18c7,10.3,8.4,19,8.4,19c0.2,0.7,0.8,0.7,1,0
  c0,0,1-8.7,8.2-19c3.3-4.9,8.5-11.4,8.5-18C67.6,31.2,59.7,23.6,50.2,23.6z M50.4,47.8c-3.5,0-6.5-3.1-6.5-6.8s3-6.6,6.5-6.6
  c3.7,0,6.6,2.9,6.6,6.6S54.1,47.8,50.4,47.8z`

export const pinDotPath = `M50.4,34.4c-3.5,0-6.5,2.9-6.5,6.6s3,6.8,6.5,6.8c3.7,0,6.6-3.1,6.6-6.8S54.1,34.4,50.4,34.4z`

export const Pin = () => {
  return (
    <svg
      className="icon pin"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path id="body" d={pinBodyPath}></path>
      <path id="dot" className="st0 counter-form" d={pinDotPath}></path>
    </svg>
  )
}

export const List = () => {
  return (
    <svg
      className="icon list"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g className="row-03">
        <polygon
          className="block-03"
          points="34.6,73.2 24.4,73.2 24.4,63 34.6,63 34.6,73.2   "
        ></polygon>
        <rect className="line-03" x="41.5" y="65.6" width="34.2" height="5.2"></rect>
      </g>
      <g className="row-02">
        <rect className="line-02" x="41.5" y="51.7" width="34.2" height="5.2"></rect>
        <polygon
          className="block-02"
          points="34.6,58.7 24.4,58.7 24.4,48.3 34.6,48.3 34.6,58.7   "
        ></polygon>
      </g>
      <g className="row-01">
        <rect className="line-01" x="41.5" y="37" width="34.2" height="5.2"></rect>
        <polygon
          className="block-01"
          points="34.6,43.9 24.4,43.9 24.4,33.6 34.6,33.6 34.6,43.9   "
        ></polygon>
      </g>
    </svg>
  )
}

export const Globe = () => {
  return (
    <svg
      className="icon globe"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        className="outline"
        d="M50,26.5c-14.4,0-26,11.5-25.9,25.9c0,14.5,11.6,26,26,26c14.5,0,25.9-11.5,25.9-26C76,38,64.5,26.5,50,26.5z
         M35,37.5c2.3-2.2,4.6-3.4,7.3-4.7c-2.4,3.2-3.9,7.5-4.8,12.6c-4.7-0.8-5.8-1.4-6.7-1.8C31.8,41.5,33.3,39.3,35,37.5z M29,55.3
        c-0.4-3.1-0.1-6.2,0.7-9.1c1.7,0.7,3.8,1.3,7.5,2C37.1,49.7,37,51,37,52.6c0,2.2,0.2,4.4,0.5,6.4C32.7,58.1,30,56.5,29,55.3z
         M35.1,67.4c-2.3-2.2-3.8-4.8-5-7.8c1.9,1,4.8,1.9,8,2.6c0.8,3.9,2,7.1,3.8,9.7C39.4,70.8,37,69.4,35.1,67.4z M48.4,73.5
        c-3.5,0-6.4-7.2-7.4-10.8c2.4,0.2,4.9,0.5,7.4,0.6V73.5z M48.5,60.4c-2.7-0.1-5.4-0.3-8.1-0.8c-0.4-2.2-0.5-4.7-0.5-7
        c0-1.5,0.1-2.7,0.1-4.1c2.7,0.4,5.6,0.5,8.5,0.6V60.4z M48.5,46.3c-2.8,0-5.5-0.1-8.2-0.5c1-5.8,3.2-11,6.1-13.3
        c0.7-0.5,1.8-1.1,2.1-1.1V46.3z M64.9,37.6c1.7,1.8,3.2,3.9,4.2,6c-0.9,0.4-2,0.9-6.7,1.8c-0.9-5.2-2.4-9.4-4.8-12.6
        C60.3,34.1,62.6,35.3,64.9,37.6z M51.5,31.4c0.3,0,1.3,0.6,2.1,1.1c2.9,2.3,5.1,7.5,6.1,13.3c-2.8,0.3-5.4,0.5-8.2,0.5V31.4z
         M51.5,49.1c3-0.1,5.8-0.3,8.5-0.5c0.1,1.4,0.1,2.6,0.1,4c0,2.4-0.1,4.8-0.5,7c-2.7,0.4-5.3,0.7-8.1,0.8V49.1z M51.5,73.5V63.3
        c2.4,0,4.9-0.4,7.4-0.6C57.9,66.3,55.1,73.5,51.5,73.5z M64.9,67.3c-1.9,2.1-4.4,3.6-6.9,4.6c1.9-2.6,3-5.8,3.9-9.6
        c3-0.6,5.7-1.4,7.8-2.4C68.7,62.7,67.2,65.2,64.9,67.3z M62.5,59c0.3-2,0.5-4.2,0.5-6.4c0-1.6,0-2.9-0.2-4.4c3.7-0.7,5.8-1.3,7.5-2
        c0.8,2.9,1.1,6,0.7,9.1C69.9,56.5,67.3,58.1,62.5,59z"
      ></path>
      <path
        className="fill st0 counter-form"
        d="M37.5,59c-4.8-0.9-7.5-2.5-8.5-3.7c-0.4-3.1-0.1-6.2,0.7-9.1c1.7,0.7,3.8,1.3,7.5,2
        C37.1,49.7,37,51,37,52.6C37,54.8,37.2,57,37.5,59z M30.1,59.6c1.2,3,2.7,5.6,5,7.8c1.9,2,4.3,3.4,6.8,4.5c-1.8-2.6-3-5.8-3.8-9.7
        C34.9,61.5,32,60.6,30.1,59.6z M42.3,32.8c-2.7,1.3-5,2.5-7.3,4.7c-1.7,1.8-3.2,4-4.2,6.1c0.9,0.4,2,1,6.7,1.8
        C38.4,40.3,39.9,36,42.3,32.8z M39.9,52.6c0,2.3,0.1,4.8,0.5,7c2.7,0.5,5.4,0.7,8.1,0.8V49.1c-2.9-0.1-5.8-0.2-8.5-0.6
        C40,49.9,39.9,51.1,39.9,52.6z M40.3,45.8c2.7,0.4,5.4,0.5,8.2,0.5V31.4c-0.3,0-1.4,0.6-2.1,1.1C43.5,34.8,41.3,40,40.3,45.8z
         M48.4,73.5V63.3c-2.5-0.1-5-0.4-7.4-0.6C42,66.3,44.9,73.5,48.4,73.5z M53.6,32.5c-0.8-0.5-1.8-1.1-2.1-1.1v14.9
        c2.8,0,5.4-0.2,8.2-0.5C58.7,40,56.5,34.8,53.6,32.5z M60.1,52.6c0-1.4,0-2.6-0.1-4c-2.7,0.2-5.5,0.4-8.5,0.5v11.3
        c2.8-0.1,5.4-0.4,8.1-0.8C60,57.4,60.1,55,60.1,52.6z M51.5,63.3v10.2c3.6,0,6.4-7.2,7.4-10.8C56.4,62.9,53.9,63.3,51.5,63.3z
         M69.1,43.6c-1-2.1-2.5-4.2-4.2-6c-2.3-2.3-4.6-3.5-7.3-4.8c2.4,3.2,3.9,7.4,4.8,12.6C67.1,44.5,68.2,44,69.1,43.6z M58,71.9
        c2.5-1,5-2.5,6.9-4.6c2.3-2.1,3.8-4.6,4.8-7.4c-2.1,1-4.8,1.8-7.8,2.4C61,66.1,59.9,69.3,58,71.9z M70.3,46.2
        c-1.7,0.7-3.8,1.3-7.5,2C63,49.7,63,51,63,52.6c0,2.2-0.2,4.4-0.5,6.4c4.8-0.9,7.4-2.5,8.5-3.7C71.4,52.2,71.1,49.1,70.3,46.2z"
      ></path>
    </svg>
  )
}

export const Close = () => {
  return (
    <svg
      className="icon arrow-2-close"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M65.1,62c1.5,1.4,1.5,3.9,0,5.4c-1.5,1.5-3.8,1.4-5.4,0l-9.4-9.5l-9.4,9.5c-1.5,1.4-3.8,1.6-5.4,0c-1.5-1.5-1.5-4,0-5.4
          l9.4-9.5L35.4,43c-1.5-1.5-1.5-3.9,0-5.4c1.5-1.4,3.9-1.4,5.4,0l9.4,9.5l9.4-9.5c1.5-1.4,3.9-1.4,5.4,0c1.5,1.5,1.5,3.9,0,5.4
          l-9.4,9.4L65.1,62z"
        ></path>
      </g>
    </svg>
  )
}

export const CloseEncircled = ({ className = "" }) => {
  return (
    <svg
      className={`icon close-encircled ${className}`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        className="circle"
        d="M50,26.5c-14.4,0-26,11.5-25.9,25.9c0,14.5,11.6,26,26,26c14.5,0,25.9-11.5,25.9-26C76,38,64.5,26.5,50,26.5z
         M63.4,60.2L58,65.6l-7.9-8L42,65.7l-5.4-5.4l8.1-8l-8.1-8l5.4-5.4l8,8.1l8-8l5.4,5.4l-8,7.8L63.4,60.2z"
      ></path>
      <polygon
        className="x st0 counter-form"
        points="58,39 50,47 42,38.9 36.6,44.3 44.7,52.3 36.6,60.3 42,65.7 50.1,57.6 58,65.6 63.4,60.2 
        55.4,52.2 63.4,44.4 "
      ></polygon>
    </svg>
  )
}

export const QuestionMark = () => {
  return (
    <svg
      className="icon questionMark"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        className="circle"
        d="M50,26.6c-14.4,0-26,11.6-26,26c0,14.3,11.6,26,26,26c14.3,0,26-11.7,26-26C76,38.2,64.3,26.6,50,26.6z
         M50,71.4c-2.7,0-4.9-2.4-4.9-5c0-2.8,2.3-5,4.9-5c2.7,0,4.9,2.4,4.9,5C54.9,69.1,52.7,71.4,50,71.4z M54.1,54.5v3.3h-8.3V50
        c0.6,0.1,1.1,0.1,1.3,0.1c3,0,4.5-1.1,4.5-4.2c0-2.5-0.6-3.7-1.8-3.7S48,43.4,48,45.9h-8.3c0-6.7,3.5-10.4,10.2-10.5
        c6,0,10.4,4.2,10.4,10.4C60.3,50.5,58.2,53.5,54.1,54.5z"
      ></path>
      <path
        className="mark st0 counter-form"
        d="M60.3,45.8c0,4.7-2.1,7.7-6.2,8.7v3.3h-8.3V50c0.6,0.1,1.1,0.1,1.3,0.1c3,0,4.5-1.1,4.5-4.2
        c0-2.5-0.6-3.7-1.8-3.7S48,43.4,48,45.9h-8.3c0-6.7,3.5-10.4,10.2-10.5C55.9,35.4,60.3,39.6,60.3,45.8z M50,61.4
        c-2.6,0-4.9,2.2-4.9,5c0,2.6,2.2,5,4.9,5s4.9-2.3,4.9-5C54.9,63.8,52.7,61.4,50,61.4z"
      ></path>
    </svg>
  )
}

export const More = ({ vertical = false }) => {
  return (
    <svg
      className={classnames("icon more", {
        vertical,
      })}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <circle id="dot-03" cx="70" cy="50" r="6.5" />
      <circle id="dot-02" cx="50" cy="50" r="6.5" />
      <circle id="dot-01" cx="30" cy="50" r="6.5" />
    </svg>
  )
}

export const Plus = () => {
  return (
    <svg
      className="icon plus"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path d="M70.2,46.6v11H55.6v14.8H44.1V57.6H29.5v-11h14.6v-14h11.4v14C55.6,46.6,70.2,46.6,70.2,46.6z"></path>
      </g>
    </svg>
  )
}

export const Check = () => {
  return (
    <svg
      className="icon check"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path d="M45.8,71.9l-21-20.8l7.8-7.9l11.8,11.7L69,28.1l8.7,7.9L45.8,71.9z"></path>
    </svg>
  )
}

export const Location = forwardRef((props, ref) => {
  const style = props.style ?? {}
  return (
    <svg
      ref={ref}
      className="icon location"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path style={style} d="M25.3,54.3l51.4-28.6L52.6,79.9l-2.9-25.7L25.3,54.3z"></path>
    </svg>
  )
})

Location.displayName = "Location"

export const Settings = () => {
  return (
    <svg
      className="icon settings"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        d="M75,63.6l-2.6,4.6l-7.4-1.3l-3.2,2.6V77L57,78.8l-4.8-5.7H48l-4.8,5.7L38.4,77l-0.1-7.4l-3.1-2.7l-7.4,1.3l-2.6-4.5l4.7-5.8
  l-0.7-4.1l-6.4-3.7l0.9-5.2l7.4-1.3l2.1-3.6l-2.6-7l4-3.4l6.5,3.7L45,32l2.6-7h5.2l2.6,7l3.9,1.4l6.4-3.8l4,3.4l-2.5,7l2,3.6
  l7.4,1.3l0.9,5.1L71,53.9L70.3,58C70.3,58,70.3,58,75,63.6z M50.1,61.6c5.2,0,9.4-4.2,9.4-9.4c0-5.2-4.2-9.4-9.4-9.4
  s-9.4,4.2-9.4,9.4C40.8,57.5,44.9,61.6,50.1,61.6z"
      ></path>
    </svg>
  )
}
